import { useState, useMemo, useEffect } from "react";
import { Link, Outlet, useNavigate } from "react-router-dom";
import cn from "classnames";
import {
  RadioGroup,
  FormControlLabel,
  Radio,
  Select,
  MenuItem,
} from "@mui/material";
import { useMaterialDirectories } from "../../api/materialsApi";
import { labelForDepartment } from "../../utils/fileUtils";
import { Role } from "../../types/user";
import { useIsMobile } from "../../hooks/useMediaQuery";
import "./materialDirectories.scss";

const MaterialDirectories = ({ role }: { role: Role }) => {
  const { data } = useMaterialDirectories();
  const isMobile = useIsMobile();
  const navigate = useNavigate();
  const directories = useMemo(() => data?.directories, [data]);
  const departments = useMemo(
    () => directories && Object.keys(directories),
    [directories]
  );
  const [selectedDir, setSelectedDir] = useState<string>();
  const [selectedDepartment, setSelectedDepartment] = useState<string | null>(
    null
  );

  useEffect(() => {
    if (departments) {
      setSelectedDepartment(departments[0]);
    }
  }, [departments]);

  return (
    <div
      className={cn({
        "wideContent paddingContent": role === "student",
        fullWidth: role === "staff",
      })}
    >
      <div className="material">
        <RadioGroup
          row
          value={selectedDepartment}
          onChange={(e) => {
            setSelectedDepartment(e.target.value);
            setSelectedDir(undefined);
            navigate(".");
          }}
        >
          {departments?.map((department: "life" | "pro") => (
            <FormControlLabel
              key={department}
              value={department}
              control={<Radio />}
              label={labelForDepartment[department]}
            />
          ))}
        </RadioGroup>

        <div className="fullWidth material-directory">
          {directories &&
            selectedDepartment &&
            (isMobile ? (
              <Select
                value={selectedDir}
                variant="standard"
                onChange={(e) => setSelectedDir(e.target.value)}
                sx={{ width: "100%" }}
                label="자료 종류"
              >
                {directories[selectedDepartment].map((dir: string) => (
                  <MenuItem value={dir} sx={{ padding: "0" }}>
                    <Link
                      style={{ width: "100%", paddingLeft: "10px" }}
                      to={`${selectedDepartment}/${dir}`}
                    >
                      {dir}
                    </Link>
                  </MenuItem>
                ))}
              </Select>
            ) : (
              <div className="vertical">
                {directories[selectedDepartment].map((dir: string) => (
                  <Link
                    to={`${selectedDepartment}/${dir}`}
                    onClick={() => setSelectedDir(dir)}
                  >
                    <button
                      key={`${selectedDepartment}${dir}`}
                      className={cn("wide-button", {
                        selected: selectedDir === dir,
                      })}
                    >
                      {dir}
                    </button>
                  </Link>
                ))}
              </div>
            ))}
          <div className={`material-directory-files ${role}`}>
            <Outlet />
          </div>
        </div>
      </div>
    </div>
  );
};

export default MaterialDirectories;
